// Packages
import axios, { AxiosError } from "axios";
import { toNamespacedPath } from "node:path/win32";
import { FormEvent, useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";

// Components
import { loginApi, generateOTPApi, CSRFToken } from "../services/auth";
import TOTP from "../components/totp";
import { useNavigate } from "react-router-dom";

// CSS
import "react-toastify/dist/ReactToastify.css";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import { changePasswordApi } from "../services/user";
import { useAuth } from "../context/authprovider";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [loginResponse, setLoginResponse] = useState({});
  const { userId } = useAuth();
  let navigate = useNavigate();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    if (newPassword != confirmNewPassword) {
      toast.error("New Password and Confirm New Password need to be the same!");
    } else if (/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g.test(newPassword)) {
        toast.error("No emoji allowed");
    } else if (newPassword.length < 8) {
      toast.error("Password length must be at least 8");
    } else if (!/[a-z]/.test(newPassword)) {
      toast.error("Password must contain small letter");
    } else if (!/[A-Z]/.test(newPassword)) {
      toast.error("Password must contain capital letter");
    } else if (!/[0-9]/.test(newPassword)) {
      toast.error("Password must contain number");
    } else if (!/[!@#$%^&*]/.test(newPassword)) {
      toast.error("Password must contain special character");
    } else {
      const formData = new FormData();
      formData.append("userId", userId!);
      formData.append("oldPassword", oldPassword);
      formData.append("newPassword", newPassword);
      formData.append("confirmNewPassword", confirmNewPassword);

      try {
        const response = await changePasswordApi(formData, userId!);
        if (response.status === 200) {
          toast.success("Your password has been changed successfully!");
        } else {
          toast.error("An error occured when you tried to login");
        }
      } catch (e) {
        if (
          e instanceof AxiosError &&
          e.response &&
          e.response.status === 400
        ) {
          toast.error("Invalid email or password");
        } else if (
          e instanceof AxiosError &&
          e.response &&
          e.response.status === 403
        ) {
          toast.error(e.response.data.message);
        }
      }
    }
  };

  return (
    <>
      <NavBar />
      <div className="mt-20 min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <ul className="list-disc">
              <li>Password length must be at least 8</li>
              <li>Password must contain capital letter</li>
              <li>Password must contain number</li>
              <li>Password must contain special character</li>
            </ul>
            <form className="space-y-6" onSubmit={handleSubmit}>
              <CSRFToken />

              {/* 3r660OmdONwBrU0ZWyCrhNCL6WplTOUE */}
              {/* <input type='hidden' name='csrfmiddlewaretoken' value='qwdoqoijdqoijoaisjdoiqjwoidj' /> */}
              <div>
                <label
                  htmlFor="username"
                  className="block text-sm font-medium text-gray-700"
                >
                  Old Password
                </label>
                <div className="mt-1">
                  <input
                    id="oldpassword"
                    name="oldpassword"
                    type="password"
                    onChange={(e) => setOldPassword(e.target.value)}
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  New Password
                </label>
                <div className="mt-1">
                  <input
                    id="newpassword"
                    name="newpassword"
                    type="password"
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Confirm New Password
                </label>
                <div className="mt-1">
                  <input
                    id="confirmnewpassword"
                    name="confirmnewpassword"
                    type="password"
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Change Password
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ChangePassword;
